export { default } from './Button';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Button/index.js
// module id = 172
// module chunks = 121